export function useUtilities() {
  /**
   *
   * @param params
   * @return {*[]}
   */
  function makeFlat(params) {
    let arr = [];
    if(params && !(Array.isArray(params))) {
      Object.keys(params).forEach((urlKey) => {
        arr.push(urlKey)
      })
    }

    if(params && Array.isArray(params)) {
      (params).forEach((url) => {
        arr.push(url)
      })
    }

    return arr;
  }

  return {
    makeFlat
  }
}